import { ViewIcon } from '@chakra-ui/icons';

const ViewCell = () => {
  return <ViewIcon/>;
};

export default ViewCell;
